import React from 'react';
import PropTypes from 'prop-types';

const BasketballPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3zm10.952 9.933c-2.17-1.062-4.473-1.283-5.276-1.288-.145-.73-.34-1.448-.586-2.153.968-.005 2.315-.153 3.267-1.207a11.361 11.361 0 0 1 2.595 4.648zm.42 3.067c0 .973-.122 1.916-.352 2.817-1.334-2.154-3.067-3.208-4.97-3.425a21.97 21.97 0 0 0-.213-2.782c3.71.102 4.848 1.104 5.421 1.784.077.523.115 1.058.115 1.606zm-6.571-6.95c-.582-.93-1.407-2.876-2.528-4.04 2.043.416 3.891 1.457 5.374 2.808-.331.552-1.02 1.232-2.774 1.232H20.8zm-4.049-4.397c.794.633 1.954 1.95 2.838 4.07-2.553-.06-3.99-.353-5.952-1.674-1.045-.706-2.26-.926-3.301-.914A11.314 11.314 0 0 1 16 4.623c.255.004.506.013.752.03zm-7.71 2.353c.98-.204 2.225-.14 4.103 1.045.37.251 2.71 1.666 6.772 1.517.22.637.416 1.338.57 2.103-7.894.314-13.978 3.76-15.847 4.856a11.343 11.343 0 0 1 4.401-9.52zM4.745 17.661c4.992-2.834 10.668-4.911 15.906-5.051.127.845.204 1.763.217 2.753-2.337.22-4.746 2.205-6.347 4.078-1.462 1.712-4.274 4.253-5.897 5.209a11.322 11.322 0 0 1-3.879-6.989zm4.818 7.72c1.827-.893 4.125-3.276 4.698-3.952 3.54-4.1 5.693-4.881 6.594-5.03-.09 2.94-.735 6.483-2.264 10.676a11.367 11.367 0 0 1-9.028-1.695zm10.476 1.253c.446-1.173 1.87-5.43 2.005-10.196 2.439.412 3.909 2.43 4.516 3.785a11.408 11.408 0 0 1-6.52 6.41z"
    />
  );
};

BasketballPath.propTypes = {
  fill: PropTypes.string,
};

export default BasketballPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/basketball.jsx